<template>
    <div :class="['modal', {'modal_opened': modalOpened}]">
        <div class="modal__overlay" @click.self="closeModal">
            <div class="modal__container">
                <button @click="closeModal" class="modal__close">
                    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M26.2777 5.17865C25.8444 4.74772 25.1418 4.74771 24.7084 5.17865L15.6847 14.1521L6.66083 5.17856C6.22748 4.74762 5.52488 4.74762 5.09152 5.17856C4.65817 5.60949 4.65817 6.30818 5.09152 6.73912L14.1154 15.7127L5.09201 24.6857C4.65866 25.1167 4.65866 25.8154 5.09201 26.2463C5.52537 26.6772 6.22797 26.6772 6.66133 26.2463L15.6847 17.2732L24.7079 26.2462C25.1413 26.6772 25.8439 26.6772 26.2772 26.2462C26.7106 25.8153 26.7106 25.1166 26.2772 24.6856L17.254 15.7127L26.2777 6.73922C26.7111 6.30828 26.7111 5.60959 26.2777 5.17865Z"
                              fill="#353535" fill-opacity="0.3"/>
                    </svg>
                </button>
                <div class="modal__content" :style="{gap: gap ? gap + 'px' : ''}">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modalOpen: false
        }
    },
    emits: ['handle-modal-close'],
    props: ['activate', 'gap'],
    computed: {
        modalOpened() {
            return this.activate || this.modalOpen
        }
    },
    methods: {
        closeModal() {
            this.$emit('handle-modal-close');
            this.modalOpen = false
        }
    },
}
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    opacity: 0;
    pointer-events: none;
    transition: .3s all;
    z-index: 9;
    backdrop-filter: blur(14px);
    top: 0;
    left: 0;

    & p {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: rgba(67, 66, 66, .7);
        @media (max-width: 767px) {
            font-size: 18px;
        }
    }

    & input {
        background: rgba(53, 53, 53, 0.05);
        border-radius: 10px;
        padding: 18px 24px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        color: #434242;
        line-height: 27px;
        width: 100%;

        &::placeholder {
            color: #AEAEAE;
        }

        @media (max-width: 767px) {
            font-size: 18px;
            height: 58px;
        }
    }

    & textarea {
        background: rgba(53, 53, 53, 0.05);
        border-radius: 10px;
        padding: 18px 24px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        color: #434242;
        line-height: 27px;
        width: 100%;
        height: 126px;
        resize: vertical;
        border: none;

        &:focus, &:active {
            outline: none;
        }

        &::placeholder {
            color: #AEAEAE;
        }

        @media (max-width: 767px) {
            font-size: 18px;
        }
    }

    &_opened {
        opacity: 1;
        pointer-events: all;
    }

    &__container {
        max-width: 836px;
        width: 100%;
        height: auto;
        padding: 88px 116px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #FBF8F4;
        border-radius: 20px;
        overflow: auto;
        max-height: calc(100vh - 64px);
        @media (max-width: 1023px) {
            max-width: calc(100vw - 80px);
            padding: 104px 70px;
        }
        @media (max-width: 767px) {
            max-width: calc(100vw - 40px);
            padding: 88px 16px;
        }
        @media (max-width: 479px) {
            max-width: calc(100vw - 20px);
            padding: 88px 8px;
        }
    }

    &__content {
        display: flex;
        flex-direction: column;
        gap: 48px;
        align-items: center;
        overflow: auto;
    }

    &__overlay {
        background: rgba(0, 0, 0, .3);
        transition: .3s all;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
    }

    &__close {
        position: absolute;
        top: 28px;
        right: 28px;
    }
}
</style>